import { render, staticRenderFns } from "./EmailSettings.vue?vue&type=template&id=4d4b3f15&"
import script from "./EmailSettings.vue?vue&type=script&lang=js&"
export * from "./EmailSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports